import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

const populationAndBuildingsSouthAmerica: LayerRaw = {
  id: 'PopulationAndBuildings',
  type: 'WMS',
  icon: 'mdi-home',
  url: '/wfas-proxy/geoserver/wms',
  title: {
    'en-US': 'Population and Buildings',
    'pt-BR': 'Populações e Edifícios',
    'es-ES': 'Poblaciones y Edificios',
    'fr-FR': 'Population et bâtiments'
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  customProperties: { group: 'reference' },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'wfas:sa_pop',
      visible: true,
      legend: {
        title: {
          'en-US': 'Population and Buildings',
          'pt-BR': 'Populações e Edifícios',
          'es-ES': 'Poblaciones y Edificios',
          'fr-FR': 'Population et bâtiments'
        },
        items: [
          {
            icon: 'mdi-square',
            color: '#2b83ba',
            text: {
              'en-US': 'Less than 100',
              'pt-BR': 'Menos de 100',
              'es-ES': 'Menos de 100',
              'fr-FR': 'Moins de 100'
            }
          },
          {
            icon: 'mdi-square',
            color: '#abdda4',
            text: {
              'en-US': '100 to 1,000',
              'pt-BR': '100 a 1,000',
              'es-ES': '100 a 1,000',
              'fr-FR': '100 à 1,000'
            }
          },
          {
            icon: 'mdi-square',
            color: '#fdae61',
            text: {
              'en-US': '1,000 to 10,000',
              'pt-BR': '1,000 a 10,000',
              'es-ES': '1,000 a 10,000',
              'fr-FR': '1,000 à 10,000'
            }
          },
          {
            icon: 'mdi-square',
            color: '#d7191c',
            text: {
              'en-US': 'More than 10,000',
              'pt-BR': 'Mais de 10,000',
              'es-ES': 'Más de 10,000',
              'fr-FR': 'Plus de 10,000'
            }
          }
        ]
      }
    }
  ]
}

export default populationAndBuildingsSouthAmerica
